












































































import { Component, Vue } from 'vue-property-decorator';


import { Device, Info } from '@/types/core';
import { DateTime } from 'luxon';
import { curCoreClient, CoreClient } from '@/services/CoreClient';

import GroupAccessEdit from '@/components/access/GroupAccessEdit.vue';
import GroupAccessEditSmall from '@/components/access/GroupAccessEditSmall.vue';
import Loading from '@/components/Loading.vue';
import VueError from '@/components/VueError.vue';
import Success from '@/components/Success.vue';
import SectionHeader from '@/components/SectionHeader.vue';


@Component({
  components: {
    Loading,
    VueError,
    SectionHeader,
    Success,
    GroupAccessEdit,
    GroupAccessEditSmall
  },
})
export default class CreateApiKey extends Vue {

  // our model
  info:Info = {} as Info;
  error:string = '';
  success:string = '';
  
  // our model
  dateTime = DateTime;
  description:string = '';
  tps:number = 5;
  tpd:number = 10000;
  level:string = 'admin';
  groupIdList:string[] = [];

  httpBusy:boolean = false;

  // internal dependencies
  private coreClient:CoreClient = curCoreClient;
  
  async mounted() {

    const reply = await this.coreClient.getInfo();
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `Unable to retrieve user info: ${reply.errorMsg}`;
    
    // we update the state
    this.info = reply.info as Info;
  }

  groupIdListUpdate(newGroupIdList:string[]) {
    
    this.groupIdList = newGroupIdList.concat();
  }

  get canCreateApiKey():boolean {
    return !this.httpBusy && this.groupIdList.length > 0;
  }

  async createApiKey() {

    this.httpBusy = true;

    this.error = '';

    const reply = await this.coreClient.createApiKey({
      tps: this.tps,
      tpd: this.tpd,
      level: this.level,
      groupIdList: this.groupIdList,
      description: this.description
    });

    this.httpBusy = false;
    
    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});

    if(reply.errorMsg)
      return this.error = `unable to create api key: ${reply.errorMsg}`;

    this.setSuccess(`api key ${reply.apiKey!.apiKey} created successfully`);
  }

  setSuccess(str:string) {
    this.success = str;
    setTimeout(() => this.$emit('cancel'), 1000);
  }

  cancel() {
    this.$emit('cancel');
  }
}
